import type { CSSProperties } from 'react';
import ThumbsUpIconSvg from '../../assets/icons/thumbs_up.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const ThumbsUpIcon: React.FC<IconProps> = ({ size = 16, className = '', style = {}, onClick }) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <ThumbsUpIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default ThumbsUpIcon;
